import _super from './super';

define(['backbone.marionette'], function(Marionette) {
  Marionette.Controller.prototype._super = _super;
  return Marionette;
});
